import { Request } from '../../serverApi/requests/Request';
import { IGetItemsResult } from '../../serverApi/types/IGetItemsResult';
import { IPagedItemsParams } from '../../serverApi/types/IPage';
import WebHttpClient from '../../WebHttpClient';
import { IListFetcher } from '../IListFetcher';
import { ListResult } from '../ListResult';

export class WebClientListResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListFetcher<TResource> {

  constructor(
    private requestType: new (params: IPagedItemsParams) => Request<IPagedItemsParams, TRequestResult>,
    private resultMapper: (result: TRequestResult) => TResource[]
  ) { }

  public fetchList(params: IPagedItemsParams): Promise<ListResult<TResource>> {
    return WebHttpClient.sendRequest(new this.requestType(params))
      .then((result: TRequestResult) => {
        const startIndex = params.page ? params.page.startIndex : 0;
        return new ListResult<TResource>(this.resultMapper(result), startIndex, result.totalCount, [], result.moreItems);
      });
  }

}
